export default __webpack_public_path__ + "static/media/HP5.d5f4f6fd.jpg";